import React, { useEffect, useState } from "react";
// import { Image } from 'react'
import header_icon from "../../assets/images/e-learning/header-icon.svg";
import { Link, useParams, useNavigate } from "react-router-dom";
import Params from "../../config/Params";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig, { BASE_URL } from "../../api/ApiConfig";
import SpinnerCmp from "../../components/SpinnerCmp";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";


function ImgVideoGallary() {
  const { t } = useTranslation();

  const [DetailsList, setDetailsList] = useState([]);
  const [detailsType, setDetailsType] = useState([]);
  console.log("detailsType", detailsType);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDetails();
    document.title = "YellowCalf | Image Video Gallary ";
  }, []);

  const params = useParams();
  let id = params.id;

  function getDetails() {
    setLoading(true);
    let newRequestBody = {
      api_key: Params.api_key,
      customer_id: Params.customer_id,
      resource_id: id,
    };
    simplePostCall(ApiConfig.E_LEARNING_DETAILS, JSON.stringify(newRequestBody))
      .then((data) => {
        // if (data.result) {
        setLoading(false);

        setDetailsList(data.datas);
        setDetailsType(data.datas);
        // }
      })
      .catch((error) => {
        console.log("api response", error);
      });
  }


const [iframeError, setIframeError] = useState(false);
  const handleIframeError = () => {
 
    console.error('Error loading iframe content.');
    setIframeError(true);
  };


  function getYouTubeEmbedUrl(url) {
  try {
    const parsed = new URL(url);

    // Case 1: normal youtube.com/watch?v=VIDEO_ID
    if (parsed.searchParams.get("v")) {
      return `https://www.youtube.com/embed/${parsed.searchParams.get("v")}`;
    }

    // Case 2: shorts => youtube.com/shorts/VIDEO_ID
    if (parsed.pathname.startsWith("/shorts/")) {
      const videoId = parsed.pathname.split("/shorts/")[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Case 3: share link => youtu.be/VIDEO_ID
    if (parsed.hostname === "youtu.be") {
      const videoId = parsed.pathname.substring(1);
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // fallback to original
    return url;
  } catch (err) {
    return url;
  }
}


function isYouTubeVideo(url) {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, "");

    // valid YouTube domains
    const validHosts = [
      "youtube.com",
      "youtu.be"
    ];

    // Check host
    if (!validHosts.includes(host)) return false;

    // Case 1: youtu.be short link → always a video
    if (host === "youtu.be") {
      return parsed.pathname.length > 1;
    }

    // Case 2: youtube.com video link
    if (host === "youtube.com") {
      // /watch?v=VIDEOID
      if (parsed.pathname === "/watch" && parsed.searchParams.has("v")) {
        return true;
      }

      // /shorts/VIDEOID
      if (parsed.pathname.startsWith("/shorts/")) {
        return true;
      }
    }

    return false;
  } catch (e) {
    // invalid URL
    return false;
  }
}



  return (
    <>
      {/* <!-- Container-fluid starts--> */}
      <div class="row e-learning-gallery">
        {loading ? (
          <SpinnerCmp />
        ) : (
          <div class="col-md-12">
            <div class="card br-15">
              {DetailsList.map((postDetail, index) => {
                console.log("postDetail", postDetail);
                return (
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1 gallery-head">
                        <h4>{postDetail.student_name}</h4>
                        <h6>
                          {/* {t("Lesson")} */}
                          <span>{postDetail.resources_name}</span>
                        </h6>
                        <h6>
                          {t("Name")}:<span>{postDetail.subject_name}</span>
                        </h6>
                        <h6>
                          Description:
                          <span>{postDetail.resources_description}</span>
                        </h6>
                      </div>

                      <div class="topic-ico">
                        <img src={header_icon} />
                      </div>
                    </div>
                  
                    {/* <div class="gallery-sec">
                      {detailsType.map((item, index) => {
                        if (item.type === "Youtube") {
                          var embededurl = item.resources_content;
                          var newurl = embededurl.replace(
                            "/watch?v=",
                            "/embed/",
                          );
                        }
                        return (
                          <div class="gallery-sec">
                            <div id="gallery">
                              {item &&
                              item.type === "image" &&
                              item.resources_content ? (
                                <img
                                  style={{ width: "100%", height: "100%" }}
                                  src={item.resources_content}
                                ></img>
                              ) : item.type === "Youtube" ? (
                                <iframe
                                  style={{ width: "100%", height: "600px" }}
                                  src={newurl}
                                  title="YouTube video player"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowfullscreen
                                ></iframe>
                              ) : item.type === "Video" ? (
                                <iframe
                                  style={{ width: "100%", height: "800px" }}
                                  src={item.upload_file}
                                  title="Video player"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowfullscreen
                                ></iframe>
                              ) : item.type === "Vimeo" ? (
                                <ReactPlayer
                                  url={item.resources_content}
                                  style={{ width: "100%", height: "800px" }}
                                  controls
                                />
                              ) : item.type === "Google Drive" ? (
                                <iframe
                                  style={{ width: "100%", height: "800px" }}
                                  src={item.resources_content}
                                  title="Google Drive"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowfullscreen
                                ></iframe>
                              ) : item.type === "Presentation" ? (
                                <iframe
                                  style={{ width: "100%", height: "800px" }}
                                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${item.upload_file}`}
                                  title=""
                                  frameborder="0"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                  allowfullscreen
                                ></iframe>
                              ) : item.type === "audio" ? (
                                <audio
                                  width={"100%"}
                                  controls
                                  src={item.resources_content}
                                />
                              ) : item.type === "PDF" ? (
                                <iframe
                                  style={{ width: "100%", height: "800px" }}
                                  src={item.upload_file}
                                ></iframe>
                              ) : item.type === "TEXT" ? (
                                <p>{item.resources_content}</p>
                              ) : item.type === "URL" ? (
                                <iframe
                                  style={{ width: "100%", height: "800px" }}
                                  src={item.resources_content}
                                ></iframe>
                              ) : (
                                <p>File is not available</p>
                              )}
                              {console.log(
                                item.type,
                                "item.type",
                                item.resources_content,
                                item.upload_file,
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div> */}

                    <div className="gallery-sec">
  {detailsType.length === 0 ? (
    <p>No data found</p>
  ) : (
    detailsType.map((item, index) => {
      let content = null;

      if (item.type === "image" && item.resources_content) {
        content = (
          <img
            style={{ width: "100%", height: "100%" }}
            src={item.resources_content}
            alt="Resource"
            onError={(e) => (e.target.outerHTML = "<p>Image not available</p>")} // fallback image
          />
        );
      } else if ((item.type === "Youtube" || item.type === "URL" ) && item.resources_content) {
        // const newurl = item.resources_content.replace("/watch?v=", "/embed/");
        const isYoutube = isYouTubeVideo(item.resources_content)
        if(isYouTubeVideo)
        {
        const newurl = getYouTubeEmbedUrl(item.resources_content);
        content = (
          <iframe
            style={{ width: "100%", height: "600px" }}
            src={newurl}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
             onError={handleIframeError}
          ></iframe>
        );
      }
      } else if (item.type === "Video" && item.upload_file) {
        content = (
          <video
            style={{ width: "100%", height: "800px" }}
            src={item.upload_file}
            controls
            onError={(e) => (e.target.outerHTML = "<p>Video not available</p>")}
          />
        );
      } else if (item.type === "Vimeo" && item.resources_content) {
        content = <ReactPlayer url={item.resources_content} controls width="100%" height="800px" />;
      } else if (item.type === "Google Drive" && item.resources_content) {
        content = (
          <iframe
            style={{ width: "100%", height: "800px" }}
            src={item.resources_content}
            title="Google Drive"
          ></iframe>
        );
      } else if (item.type === "Presentation" && item.upload_file) {
        content = (
          // <iframe
          //   style={{ width: "100%", height: "800px" }}
          //   src={`https://view.officeapps.live.com/op/embed.aspx?src=${BASE_URL + item.upload_file}`}
          //   // src={`${BASE_URL + item.upload_file}`}
          //   title="Presentation"
          // ></iframe>

  //          <iframe
  //   src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
  //     "https://api.yellowcalf.com:3000/uploads/1609/resources/presentation/1768901015.ppt"
  //   )}`}
  //   width="100%"
  //   height="100%"
  //   frameBorder="0"
  //   title="PPT Viewer"
  // />

  <div>
  <iframe
    src={`https://docs.google.com/gview?url=${encodeURIComponent(
    `${BASE_URL + item.upload_file}`
    )}&embedded=true`}
    width="100%"
    style={{ height: "100vh", border: "none" }}
    title="PPT Viewer"
  />
</div>

    
        );
      } else if (item.type === "audio" && item.resources_content) {
        content = (
          <audio
            controls
            src={item.resources_content}
            onError={(e) => (e.target.outerHTML = "<p>Audio not available</p>")}
          />
        );
      } else if (item.type === "PDF" && item.upload_file) {
        content = <iframe style={{ width: "100%", height: "800px" }} src={BASE_URL + item.upload_file}></iframe>;
      } else if (item.type === "TEXT" && item.resources_content) {
        content = <p>{item.resources_content}</p>;
      } else if (item.type === "URL" && item.resources_content) {
        content = <iframe style={{ width: "100%", height: "800px" }} src={item.resources_content}></iframe>;
      } else {
        content = <p>No data found for this resource</p>;
      }

      return (
        <div className="gallery-item" key={index}>
          {content}
        </div>
      );
    })
  )}
</div>

                
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {/* <!-- Container-fluid Ends--> */}
    </>
  );
}

export default ImgVideoGallary;
